<div class="profile-page bg-secondary">
    <main class="pt-3">
        <div class="container-fluid wow fadeIn">
            <legend>Agent Monthly Sales</legend>

            <b-row>
                <b-col sm="6" md="3">
                    <b-form-group label-size="sm" label="Month:">
                        <b-form-select v-model="month" :options="[
                            {value:1,text:'January'},{value:2,text:'February'},{value:3,text:'March'},
                            {value:4,text:'April'},{value:5,text:'May'},{value:6,text:'June'},
                            {value:7,text:'July'},{value:8,text:'August'},{value:9,text:'September'},
                            {value:10,text:'October'},{value:11,text:'November'},{value:12,text:'December'}
                        ]" size="sm"></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="6" md="3">
                    <b-form-group label-size="sm" label="Year:">
                        <b-form-input v-model="year" type="number" size="sm"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="6">
                    <br />
                    <b-button type="button" @click="getReport" pill variant="outline-dark">
                        Retrieve Report
                    </b-button>
                    <b-button type="button" @click="downloadCsv" pill variant="outline-success">
                        Download CSV
                    </b-button>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <strong>Total Records : {{totalRecords}}</strong>
                </b-col>
            </b-row>

            <div class="row pt-3">
                <div class="col">
                    <div class="table-responsive-md">
                    <b-table striped hover bordered small :items="items" :fields="fields">
                        <template #cell(userId)="data">
                            <router-link class="btn btn-sm btn-outline-primary"
                                :to="{ path: '/agentproductreport', query: { userId: data.item.userId, fullName: data.item.fullName } }">
                                View Products
                            </router-link>
                            <router-link class="btn btn-sm btn-outline-info ml-1"
                                :to="{ path: '/agentgrowthreport', query: { userId: data.item.userId } }">
                                View Growth
                            </router-link>
                            <router-link class="btn btn-sm btn-outline-secondary ml-1" :to="'/customertransactions?userId=' + data.item.userId">
                                View Transactions
                            </router-link>
                        </template>
                    </b-table>
                    </div>
                    <br />
                    <b-pagination @input="handlePageClick" v-model="selectedPage" :total-rows="totalRecords"
                        :per-page="perPage" first-number last-number></b-pagination>
                </div>
            </div>

            <div class="vld-parent">
                <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
            </div>
        </div>
    </main>
</div>
